var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import Text from '../Text';
import colors from '../../themes/colors';
var colorMapping = {
    "default": colors.neutral10,
    info: colors.blue10,
    success: colors.green10,
    warning: colors.yellow10,
    danger: colors.red10
};
var PillWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 100px;\n  background-color: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 100px;\n  background-color: ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return colorMapping[variant || 'default'];
});
var Pill = function (_a) {
    var label = _a.label, children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    return (_jsxs(PillWrapper, __assign({ variant: variant }, { children: [label && (_jsx(Text, __assign({ variant: "tag1Semibold", color: "neutral90" }, { children: label }))), children] })));
};
export default Pill;
var templateObject_1;
